// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.swal2-image {
        max-width: 200px;
        max-height: 200px;
        border: dashed 1px maroon;
        padding: 5px;
}
.tox .tox-form__group.noty-html-helper-panel {
        padding: 0;
        margin-bottom: 16px !important;
}
.tox .noty-html-helper-card {
        padding: 12px 14px;
        border: 1px solid rgba(13, 49, 98, 0.25);
        border-radius: 12px;
        background: linear-gradient(135deg, #fefefe 0%, #f3f8ff 70%);
        box-shadow: 0 10px 25px rgba(8, 29, 71, 0.12);
        background-clip: padding-box;
}
.tox .noty-html-helper__label {
        display: block;
        font-size: 0.8rem;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: #0b3a6f;
        margin-bottom: 8px;
}
.tox .noty-html-helper__input {
        width: 100%;
        resize: vertical;
        min-height: 52px;
        margin-bottom: 10px;
}
.tox .noty-html-helper__suggestions {
        margin-bottom: 8px;
}
.tox .noty-html-helper__select {
        width: 100%;
        border-radius: 6px;
        border: 1px solid rgba(13, 49, 98, 0.3);
        padding: 6px 10px;
        font-size: 0.85rem;
}
.tox .noty-html-helper__actions {
        margin-bottom: 6px;
}
.tox .noty-html-helper__button {
        border: none;
        border-radius: 999px;
        padding: 6px 16px;
        background: #0f9d58;
        color: #fff;
        font-weight: 600;
        cursor: pointer;
        font-size: 0.8rem;
        box-shadow: 0 5px 14px rgba(15, 157, 88, 0.3);
}
.tox .noty-html-helper__button:disabled {
        opacity: 0.6;
        cursor: not-allowed;
        box-shadow: none;
}
.tox .noty-html-helper__status {
        font-size: 0.72rem;
        color: #4b5563;
        line-height: 1.2;
}
.tox .noty-html-helper__status--error {
        color: #b3261e;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
